import OrganizationFeaturePartnerPortalNotification from './OrganizationFeaturePartnerPortalNotification';
import type { IOrganizationFeaturePartnerPortalNotifications } from './OrganizationFeaturePartnerPortalNotifications.interface';

export default class OrganizationFeaturePartnerPortalNotifications
  implements IOrganizationFeaturePartnerPortalNotifications {
  partnerAdded: OrganizationFeaturePartnerPortalNotification;
  dealShared: OrganizationFeaturePartnerPortalNotification;
  dealStageChange: OrganizationFeaturePartnerPortalNotification;
  newNote: OrganizationFeaturePartnerPortalNotification;
  newFile: OrganizationFeaturePartnerPortalNotification;

  static build = (data: IOrganizationFeaturePartnerPortalNotifications) =>
    new OrganizationFeaturePartnerPortalNotifications(data);
  static blank = () => new OrganizationFeaturePartnerPortalNotifications();

  /**
   * Constructor
   * @param {IOrganizationFeaturePartnerPortalNotifications} data
   */
  constructor(data?: IOrganizationFeaturePartnerPortalNotifications) {
    this.partnerAdded = new OrganizationFeaturePartnerPortalNotification(data?.partnerAdded);
    this.dealShared = new OrganizationFeaturePartnerPortalNotification(data?.dealShared);
    this.dealStageChange = new OrganizationFeaturePartnerPortalNotification(
      data?.dealStageChange
    );
    this.newNote = new OrganizationFeaturePartnerPortalNotification(data?.newNote);
    this.newFile = new OrganizationFeaturePartnerPortalNotification(data?.newFile);
  }
}
